// window.__NODEOWNER_CONFIG__ is set by config.js, generated at container
// start from DISCOVERY_API_URL (see docker-entrypoint.sh) -- this is the
// one thing this app knows at deploy time, everything else
// (auth-api-local's address, node_owner_uid/owner_name) is discovered
// through it at runtime, same pattern as kwms-web.
declare global {
  interface Window {
    __NODEOWNER_CONFIG__?: {
      discoveryApiUrl: string;
    };
  }
}

function required(value: string | undefined, name: string): string {
  if (!value) {
    throw new Error(`${name} is not set — is config.js missing or docker-entrypoint.sh misconfigured?`);
  }
  return value;
}

export const discoveryApiUrl = required(window.__NODEOWNER_CONFIG__?.discoveryApiUrl, "discoveryApiUrl");
